import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { EulaService, UserSessionApiService } from '@services';
import { UserDataService } from '@services';
import { take } from 'rxjs';

import { WINDOW } from '../../../core/window.token';

@Component({
  selector: 'logout-component',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {
  @Input() email = '';
  @Output() signedOut = new EventEmitter<void>();
  @Output() menuClose = new EventEmitter<void>();

  private window = inject(WINDOW);
  private userDataService = inject(UserDataService);
  private userSessionApiService = inject(UserSessionApiService);
  private eulaService = inject(EulaService);

  onOpenEula(): void {
    this.menuClose.emit();
    this.eulaService
      .checkUserEulaAcceptance()
      .pipe(take(1))
      .subscribe({
        next: (eulaData) => {
          this.eulaService.showEulaDialog(eulaData, false, true).pipe(take(1)).subscribe();
        },
        error: (error) => {
          console.error('Error loading EULA:', error);
        }
      });
  }

  onSignOut(): void {
    const returnUrl = this.window.location.href;
    this.userDataService.clearUserData();
    this.signedOut.emit();
    this.userSessionApiService.logout(returnUrl);
  }
}
